var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEmbedModular = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentcolor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.333,
  d: "M10.26 2.926a.667.667 0 0 0 1.12-.316 1.666 1.666 0 1 1 2.009 2.01.667.667 0 0 0-.316 1.12l1.122 1.122a1.61 1.61 0 0 1 0 2.276l-1.122 1.122a.667.667 0 0 1-1.12-.316 1.667 1.667 0 1 0-2.01 2.01.668.668 0 0 1 .316 1.12l-1.122 1.121a1.609 1.609 0 0 1-2.276 0L5.74 13.073a.667.667 0 0 0-1.12.316 1.667 1.667 0 1 1-2.01-2.01.667.667 0 0 0 .317-1.12L1.804 9.138a1.61 1.61 0 0 1 0-2.276L2.926 5.74a.667.667 0 0 1 1.12.316 1.667 1.667 0 1 0 2.01-2.01.667.667 0 0 1-.317-1.12l1.122-1.122a1.61 1.61 0 0 1 2.276 0l1.122 1.122Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgEmbedModular);
export default ForwardRef;